module.exports = __webpack_public_path__ + "img/dots-vertical.42fec6a7.svg";